import { Fragment, type ReactElement } from 'react';

/**
 * A translated sentence whose NUMBERS (a time, a count, a code) are set in the mono face while the words stay in the sans
 * face (D511, audit consoles F14 + the typography pass). The mono face belongs to the number itself — a whole sentence in
 * mono ("Recusa automática em 8:00") reads as a code listing, not as a message.
 *
 * `render` receives the placeholder values to hand to the catalogue (`t` or `tp`); each one is a marker this component then
 * swaps for a `.tnum` span carrying the real value:
 *
 *   <TnumText render={(v) => t('queue.deadline', v)} values={{ time: formatCountdown(left) }} />
 *
 * Moved here from four byte-identical app copies (D548: Balcão, Loja, Frota, Central).
 */
const OPEN = '\u0001';
const CLOSE = '\u0002';
const MARKER = new RegExp(`(${OPEN}[^${CLOSE}]*${CLOSE})`);

export function TnumText({ render, values }: { render: (marked: Record<string, string>) => string; values: Readonly<Record<string, string | number>> }): ReactElement {
  const marked: Record<string, string> = {};
  for (const key of Object.keys(values)) marked[key] = `${OPEN}${key}${CLOSE}`;
  const parts = render(marked).split(MARKER);
  // One wrapping span: inside a flex parent (a `Button`, a `Badge`) the words and the numbers stay one item, so the spaces between them survive.
  return (
    <span>
      {parts.map((part, i) => {
        if (part === '') return null;
        if (part.startsWith(OPEN)) {
          const key = part.slice(1, -1);
          return (
            <span key={i} className="tnum">
              {String(values[key] ?? '')}
            </span>
          );
        }
        return <Fragment key={i}>{part}</Fragment>;
      })}
    </span>
  );
}
